import React from "react"
import styled from "styled-components"
import CommonText from "@/components/common/Text"
import { BREAKPOINTS } from "@/styles/themeSettings"
import LinkButton from "@/components/common/Buttons/LinkButton"
import { BUTTON_VARIANTS } from "@/constants"
import { getButtonLinkData } from "@/components/common/Buttons/Button"

const ButtonWrapper = styled.div`
	position: absolute;
	width: calc(100vw - var(--paddingX));
`

const CommonButton = styled(LinkButton)`
	position: absolute;
	top: 0;
	right: var(--paddingX);
`

const Text = styled(CommonText)`
	width: 62.5%;
	font-weight: ${({ theme }) => theme.fontWeight.semiBold};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		width: 60%;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 100%;
	}
`

const HeaderButton = ({ data, color }) => {
	const header = data?.header || ""
	const buttonData = getButtonLinkData(data?.button)

	return (
		<>
			<Text color={color} tag="h2" className="typo-borna typo-borna-36 col-desktop-8 col-tablet-8 col-mobile-8 header">
				{header}
			</Text>
			<ButtonWrapper>
				<CommonButton className="link-button" {...buttonData} variant={BUTTON_VARIANTS.TERTIARY} />
			</ButtonWrapper>
		</>
	)
}

export default HeaderButton
